module.exports = __webpack_public_path__ + "img/smiling-brunette-on-dentist-chair.55bda55f.png";